import { z } from 'zod';
import { PERMISSIONS, ROLE_SCOPE_TYPES } from '../permissions.js';
import { text } from './common.js';
export const roleSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    isBuiltin: z.boolean(),
    scopeType: z.enum(ROLE_SCOPE_TYPES),
    permissions: z.array(z.enum(PERMISSIONS)),
    userCount: z.number().int(),
});
export const roleCreateSchema = z.object({
    name: text(2, 60),
    scopeType: z.enum(ROLE_SCOPE_TYPES),
    permissions: z.array(z.enum(PERMISSIONS)).max(PERMISSIONS.length),
});
export const roleEditSchema = roleCreateSchema.partial();
export const permissionInfoSchema = z.object({
    key: z.enum(PERMISSIONS),
    label: z.string(),
    group: z.string(),
});
/** Editable settings (plan.md §3). Mailboxes are read-only from the API and come from config. */
export const settingsSchema = z.object({
    field_tech_manager_user_id: z.number().int().positive().nullable(),
    reminder_hour_local: z.number().int().min(0).max(23),
    default_visit_duration: z.number().int().min(15).max(720),
    on_time_tolerance_minutes: z.number().int().min(0).max(240),
    calendar_owner_mailbox: z.string(),
    sender_mailbox: z.string(),
});
export const settingsEditSchema = settingsSchema
    .pick({
    field_tech_manager_user_id: true,
    reminder_hour_local: true,
    default_visit_duration: true,
    on_time_tolerance_minutes: true,
})
    .partial()
    .strict();
//# sourceMappingURL=roles.js.map